module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-SemiboldItalic-2010272e.ttf";